export class GADissect {
    private emptyValue: string = ''

    private readCookie() {
        return document.cookie
    }

    public cookieProperties() {
        const cookie = this.readCookie();
        let properties: any = {};

        let referralCookie = this.parseCookieFragment(cookie, "__utmzz=", ";");
        if (!referralCookie) {
            referralCookie = this.parseCookieFragment(cookie, "__utmz=", ";");
        }

        const utmzlp = this.parseCookieFragment(cookie, "__utmzlp=", ';');

        const ga_clid = this.parseCookieFragment(cookie, "_ga=", ";");
        let source = this.parseCookieFragment(referralCookie, "utmcsr=", "|");
        let medium = this.parseCookieFragment(referralCookie, "utmcmd=", "|");
        const term = this.parseCookieFragment(referralCookie, "utmctr=", "|");
        const content = this.parseCookieFragment(referralCookie, "utmcct=", "|");
        const campaign = this.parseCookieFragment(referralCookie, "utmccn=", "|");
        const gclid = this.parseCookieFragment(referralCookie, "utmgclid=", "|");
        if (gclid !== this.emptyValue) {
            source = "google";
            medium = "cpc"
        }
        const customVarCookie = this.parseCookieFragment(cookie, "__utmv=", ";");
        let customSegment = this.emptyValue;
        if (customVarCookie !== this.emptyValue) {
            let match = customVarCookie.match(/[1-9]*?\.([^|]*)/);
            if (match && match[1] && match[1] !== "") {
                customSegment = match[1]
            }
        }
        const uniqueVisitorCookie = this.parseCookieFragment(cookie, "__utma=", ";");
        const uniqueCookieChunks = uniqueVisitorCookie.split(".");
        const numVisits = parseInt(uniqueCookieChunks[5], 10) || 0;

        properties.utmzlp = utmzlp;
        properties.ga_clid = ga_clid;
        properties.source = source;
        properties.medium = medium;
        properties.term = term;
        properties.content = content;
        properties.campaign = campaign;
        properties.customSegment = customSegment;
        properties.numVisits = numVisits;
        properties.uniqueVisitorID = uniqueCookieChunks.slice(0, 3).join(".");
        properties.crossDomainVisitorID = uniqueCookieChunks[1];

        return properties
    }

    private parseCookieFragment(fragment: string, startString: string, endString: string) {
        if (!fragment || fragment === "" || !startString || startString === "" || !endString || endString === "") {
            return this.emptyValue
        }
        let substring = this.emptyValue;
        const startIndex = fragment.indexOf(startString);
        const assignmentIndex = startString.indexOf("=") + 1;
        if (startIndex > -1) {
            let endIndex = fragment.indexOf(endString, startIndex);
            if (endIndex < 0) {
                endIndex = fragment.length
            }
            substring = decodeURIComponent(fragment.substring(startIndex + assignmentIndex, endIndex))
        }
        return substring
    }
};